import { Component, OnInit } from '@angular/core';
import {EnvironmentService} from "../../_services/environment.service";


@Component({
  selector: 'app-Newsletters',
  templateUrl: './Newsletters.component.html',
  styleUrls: ['./Newsletters.component.scss']
})



export class NewslettersComponent implements OnInit {
  status=false;
  open: boolean=true;
  // load: any;
  constructor(public envService: EnvironmentService) {
    // this.load=new Promise((resolve) => {
    //   this.loadFile();

    // })
  }
  // loadFile(){
  //   let node=document.createElement('script');
  //   node.src='//lacounty.us11.list-manage.com/generate-js/?u=3d79962a0e2ac6a48c94d04e8&fid=12718&show=10';
  //   node.type='text/javascript';
  //   node.async=false;
  //   node.charset='utf-8';
  //   document.getElementsByTagName('i')[0].appendChild(node);
  // }

  ngOnInit() {
  }

}
